import store from "../vuex/store";

const isAvailable = (roles) => {
    return store.getters.meRoles.map(item => roles.includes(item)).includes(true)
}

export function isAdmin(to, from, next) {

    if (isAvailable(['admin', 'welder'])) {
        next()
    } else {
        next({name: "Table"})

    }
}






